import ThemeConf from '@/types/ThemeConf';

export function applyStyle(theme: ThemeConf) {
  if (theme && theme.color_primary) {
    // eslint-disable
    const css = `
        .sidebar .themed,
        .sidebar .toc-active,
        .sidebar .references a,
        .sidebar footer,
        .sidebar .training-options .fa-volume-up,
        .sidebar .training-options .options-container.checked,
        .sidebar button.back {
          color: ${theme.color_primary} !important;
        }
        .sidebar .themed-background-color {
          background-color: ${theme.color_primary} !important;
        }
      `;
    // eslint-enable

    // Write branded styles to body
    const style: HTMLStyleElement =
      document.querySelector('[data-type=\'theme\']') ||
      document.createElement('style');
    style.type = 'text/css';
    style.dataset.type = 'theme';
    style.appendChild(document.createTextNode(css));
    document.getElementsByTagName('head')[0].appendChild(style);
  }
}
